module.exports = __webpack_public_path__ + "img/ic_call.67646df7.svg";